<template>
  <section v-on:click="sectionClicked" class="pagePubDetail">
    <Header ref="header" class="scrolled"/>
    <SkAnimtaion :article="true" v-if="loading"/>
    <div class="notFound" v-else-if="!detail">
      <img src="../assets/not-found.png">
      <h4>404</h4>
      <h2>Halaman tidak ditemukan</h2>
      <p>We can't find the page you looking for</p>
    </div>
    <div v-else>
      <div class="articleDetail">
        <div class="articleHeader">
          <div class="ahL">
            <div class="breadcrumb">
              <router-link to="/"
                class="bc">Home</router-link>
              <span class="dv">/</span>
              <router-link to="/publication"
                class="bc">Publication</router-link>
              <span class="dv">/</span>
              <span class="bc">{{detail.title}}</span>
            </div>
            <h2 class="articleTitle">{{detail.title}}</h2>
            <div class="publishTime">
              {{detail.publishDate | moment('MMM YYYY')}}
            </div>
            <div class="publishTime" v-if="1>2">
              {{detail.publishDate | moment('MMM YYYY')}}
              <span class="bull">&bull;</span>
              340 views
              <span class="bull">&bull;</span>
              <span class="category">Report</span>
            </div>
          </div>
          <div class="ahR">
            <div class="articleAction embed" v-on:click="embed"
              v-if="detail.type !== 'youtube' && 1>2">Embed</div>
            <div class="articleAction share" v-on:click="share">Share</div>
            <div class="articleAction download" v-on:click="download"
              v-if="detail.type === 'video'">Download</div>
            <a :href="detail.pdf" :download="`${detail.title}.pdf`" target="_blank"
              class="articleAction download" v-on:click="download"
              v-else-if="detail.type === 'pdf'">Download</a>
            <a :href="detail.audio" :download="`${detail.title}.pdf`" target="_blank"
              class="articleAction download" v-on:click="download"
              v-else-if="detail.type === 'audio'">Download</a>
            <a :href="detail.imageLg" download target="_blank"
              class="articleAction download" v-on:click="download"
              v-else-if="detail.type === 'image'">Download</a>
            <div class="moreCnt">
              <button class="articleAction moreBtn"
                v-on:click.stop="moreOpen = !moreOpen">Options</button>
              <div class="moreMenu" v-if="moreOpen" v-on:click.stop="doNothing">
                <div class="articleAction embed" v-on:click="embed"
                  v-if="detail.type !== 'youtube' && 1>2">Embed</div>
                <div class="articleAction share" v-on:click="share">Share</div>
                <div class="articleAction download" v-on:click="download"
                  v-if="detail.type === 'video'">Download</div>
                <a :href="detail.pdf" :download="`${detail.title}.pdf`" target="_blank"
                  class="articleAction download" v-on:click="download"
                  v-else-if="detail.type === 'pdf'">Download</a>
                <a :href="detail.audio" :download="`${detail.title}.pdf`" target="_blank"
                  class="articleAction download" v-on:click="download"
                  v-else-if="detail.type === 'audio'">Download</a>
                <a :href="detail.imageLg" download target="_blank"
                  class="articleAction download" v-on:click="download"
                  v-else-if="detail.type === 'image'">Download</a>
              </div>
            </div>
          </div>
        </div>
        <div class="protected" v-if="detail.protected">
          <img src="../assets/padlock.png">
          <h4>Akses Terbatas</h4>
          <div v-if="detail.password">
            <p>Masukan password untuk membuka konten ini</p>
            <form v-on:submit.prevent="getData">
              <div class="inputCnt">
                <div class="privateIcon"></div>
                <input type="password" placeholder="• • • •"
                  v-model="pwd">
                <button class="submitBtn" v-on:click="getData"></button>
              </div>
            </form>
          </div>
          <p v-else>Kamu tidak punya hak akses untuk membuka konten ini</p>
        </div>
        <div v-else>
          <div class="articleContent" v-if="detail.type === 'pdf'">
            <div id="dfCnt"></div>
          </div>
          <div class="articleContent image" v-else-if="detail.type === 'image'">
            <div class="theImg" :style="{'background-image': `url(${detail.imageLg})`}"></div>
          </div>
          <div class="articleContent video" v-else-if="detail.type === 'video'">
            <VuePlyr ref="video" :options="{ hideControls: false }">
              <video></video>
            </VuePlyr>
          </div>
          <div class="articleContent audio" v-else-if="detail.type === 'audio'">
            <VuePlyr ref="audio" :options="{ hideControls: false }">
              <video></video>
            </VuePlyr>
          </div>
          <div class="articleContent html" v-else-if="detail.type === 'html'"
            v-html="detail.htmlContent.html"></div>
          <div class="articleContent video youtube" v-else-if="detail.type === 'youtube'">
            <iframe :src="detail.embedUri" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media;
              gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
        <div class="allContentCnt" v-if="1>2">
          <h2 class="relatedTitle">Related contents</h2>
          <div class="allContent">
            <div class="contentSc artc">
              <div class="contentCnt">
                <div class="contentItem artc" v-for="i in 3" :key="i"
                  :class="{pdf: true}">
                  <div class="contentImg">
                    <a :href="`/publication/detail/seaboung-2-0-report`"
                      class="lnk">
                      <img src="../assets/img-thumb.jpg" class="theImg">
                    </a>
                  </div>
                  <div class="contentInfo">
                    <h4><a :href="`/publication/detail/seaboung-2-0-report`">
                      Seabound 2.0 Report
                    </a></h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="preview" v-if="detail.status === 'pending'">
        This is a preview, content will be published at
        <b>{{detail.publishDate | moment('dddd, D MMM YYYY HH:mm')}}</b></div>
    </div>
    <div v-if="1>2">
      <div class="articleDetail">
        <div class="articleHeader">
          <div class="ahL">
            <div class="breadcrumb">
              <router-link to="/"
                class="bc">Home</router-link>
              <span class="dv" v-if="detail.category.slug !== 'amagram-internal'
                && detail.category.parent">/</span>
              <router-link v-if="detail.category.slug !== 'amagram-internal'
                && detail.category.parent"
                :to="`/category/${detail.category.parent.slug}`"
                class="bc">{{detail.category.parent.name}}</router-link>
              <span class="dv">/</span>
              <router-link :to="`/${detail.category.slug}`"
                class="bc">{{detail.category.name}}</router-link>
              <span class="dv"
                v-if="detail.category.slug === 'amagram'
                || detail.category.slug === 'amagram-internal'
                || detail.category.slug === 'leaders-newsletter'
                || detail.category.slug === 'bulletin'">/</span>
              <router-link
                v-if="detail.category.slug === 'amagram'
                || detail.category.slug === 'amagram-internal'
                || detail.category.slug === 'leaders-newsletter'
                || detail.category.slug === 'bulletin'"
                :to="`/${detail.category.slug}/edition/${detail.publishYear}?u=${uuid}`"
                class="bc">Edisi tahun
                {{detail.publishYear}}</router-link>
              <span class="dv">/</span>
              <span class="bc">{{detail.title}}</span>
            </div>
            <h2 class="articleTitle">{{detail.title}}</h2>
            <div class="publishTime">
              {{detail.publishDate | moment('MMM YYYY')}}
              <span class="bull">&bull;</span>
              {{detail.viewCountStr}} views
              <span class="bull">&bull;</span>
              <span class="category">{{detail.category.name}}</span>
            </div>
          </div>
          <div class="ahR">
            <a :href="detail.buyNowUrl" target="_blank" class="articleAction buyNow"
              v-if="detail.buyNowUrl">
              Beli Sekarang</a>
            <div class="articleAction embed" v-on:click="embed"
              v-if="detail.type !== 'youtube' && 1>2">Embed</div>
            <div class="articleAction share" v-on:click="share">Bagikan</div>
            <div class="articleAction download" v-on:click="download"
              v-if="detail.type === 'video'">Download</div>
            <a :href="detail.pdf" :download="`${detail.title}.pdf`" target="_blank"
              class="articleAction download" v-on:click="download"
              v-else-if="detail.type === 'pdf'">Download</a>
            <a :href="detail.audio" :download="`${detail.title}.pdf`" target="_blank"
              class="articleAction download" v-on:click="download"
              v-else-if="detail.type === 'audio'">Download</a>
            <a :href="detail.imageLg" download target="_blank"
              class="articleAction download" v-on:click="download"
              v-else-if="detail.type === 'image'">Download</a>
            <div class="moreCnt">
              <button class="articleAction moreBtn"
                v-on:click.stop="moreOpen = !moreOpen">Opsi Lainya</button>
              <div class="moreMenu" v-if="moreOpen" v-on:click.stop="doNothing">
                <div class="articleAction embed" v-on:click="embed"
                  v-if="detail.type !== 'youtube' && 1>2">Embed</div>
                <div class="articleAction share" v-on:click="share">Bagikan</div>
                <div class="articleAction download" v-on:click="download"
                  v-if="detail.type === 'video'">Download</div>
                <a :href="detail.pdf" :download="`${detail.title}.pdf`" target="_blank"
                  class="articleAction download" v-on:click="download"
                  v-else-if="detail.type === 'pdf'">Download</a>
                <a :href="detail.audio" :download="`${detail.title}.pdf`" target="_blank"
                  class="articleAction download" v-on:click="download"
                  v-else-if="detail.type === 'audio'">Download</a>
                <a :href="detail.imageLg" download target="_blank"
                  class="articleAction download" v-on:click="download"
                  v-else-if="detail.type === 'image'">Download</a>
              </div>
            </div>
          </div>
        </div>
        <div class="protected" v-if="detail.protected">
          <img src="../assets/padlock.png">
          <h4>Akses Terbatas</h4>
          <div v-if="detail.password">
            <p>Masukan password untuk membuka konten ini</p>
            <form v-on:submit.prevent="getData">
              <div class="inputCnt">
                <div class="privateIcon"></div>
                <input type="password" placeholder="• • • •"
                  v-model="pwd">
                <button class="submitBtn" v-on:click="getData"></button>
              </div>
            </form>
          </div>
          <p v-else>Kamu tidak punya hak akses untuk membuka konten ini</p>
        </div>
        <div v-else>
          <div class="articleContent" v-if="detail.type === 'pdf'">
            <div id="dfCnt"></div>
          </div>
          <div class="articleContent image" v-else-if="detail.type === 'image'">
            <div class="theImg" :style="{'background-image': `url(${detail.imageLg})`}"></div>
          </div>
          <div class="articleContent video" v-else-if="detail.type === 'video'">
            <VuePlyr ref="video" :options="{ hideControls: false }">
              <video></video>
            </VuePlyr>
          </div>
          <div class="articleContent audio" v-else-if="detail.type === 'audio'">
            <VuePlyr ref="audio" :options="{ hideControls: false }">
              <video></video>
            </VuePlyr>
          </div>
          <div class="articleContent html" v-else-if="detail.type === 'html'"
            v-html="detail.htmlContent.html"></div>
          <div class="articleContent video youtube" v-else-if="detail.type === 'youtube'">
            <iframe :src="detail.embedUri" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media;
              gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
        <div class="allContentCnt" v-if="related && related.length > 0">
          <h2 class="sectionTitle" v-if="detail.category.slug === 'amagram'
            || detail.category.slug === 'leaders-newsletter'
            || detail.category.slug === 'amagram-internal'
            || detail.category.slug === 'bulletin'">Lihat edisi lainya
            <a :href="`/${detail.category.slug}/edition/${detail.publishYear}`"
              v-if="detail">
              Lihat semua edisi {{detail.publishYear}}</a>
          </h2>
          <h2 class="sectionTitle" v-else>Konten Terkait</h2>
          <div class="allContent">
            <div class="contentSc artc">
              <div class="contentCnt">
                <div class="contentItem artc" v-for="(item, index) in related" :key="index"
                  :class="item.type">
                  <div :class="{contentImg: true, shortImg: item.publishYear < 2018}">
                    <a :href="`/${item.category.slug}/${item.slug}?u=${uuid}`"
                      class="lnk">
                      <img :src="item.thumb" class="theImg" v-if="item.thumb">
                      <div class="theImg noImg" v-else></div>
                    </a>
                  </div>
                  <div class="contentInfo">
                    <div class="category">
                      <a :href="`/${item.category.slug}?u=${uuid}`">{{item.category.name}}</a>
                    </div>
                    <h4><a :href="`/${item.category.slug}/${item.slug}?u=${uuid}`">
                        {{item.title | substr(65, '...')}}
                    </a></h4>
                    <div class="date">
                      <a :href="`/${item.category.slug}/${item.slug}?u=${uuid}`">
                        {{item.viewCountStr}} views &bull;
                        {{item.publishDate | moment('MMM YYYY')}}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="preview" v-if="detail.status === 'pending'">
        This is a preview, content will be published at
        <b>{{detail.publishDate | moment('dddd, D MMM YYYY HH:mm')}}</b></div>
    </div>
    <ShareDialog2 ref="shareDialog"/>
    <EmbedDialog ref="embedDialog"/>
    <DownloadSelector ref="downloadSelector"/>
  </section>
</template>

<script>
import VuePlyr from 'vue-plyr';
import 'vue-plyr/dist/vue-plyr.css';

import SkAnimtaion from '@/components/SkAnimtaion.vue';
import Header from '@/components/Header.vue';
import ShareDialog2 from '@/components/ShareDialog2.vue';
import EmbedDialog from '@/components/EmbedDialog.vue';
import DownloadSelector from '@/components/DownloadSelector.vue';

export default {
  name: 'read',
  components: {
    SkAnimtaion,
    Header,
    ShareDialog2,
    VuePlyr,
    EmbedDialog,
    DownloadSelector,
  },
  data() {
    return {
      loading: true,
      detail: {
        title: 'Issue Brief Ruang Tengah Edisi 14',
        publishDate: new Date(),
        type: 'pdf',
        pdf: '',
      },
      qrString: null,
      loadingQr: true,
      qrError: false,
      related: [],
      sessionId: '',
      currentPage: 1,
      inPage: true,
      singingAl: true,
      moreOpen: false,
      uuid: '',
      pwd: '',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {
      this.moreOpen = false;
      if (this.$refs.header) this.$refs.header.sectionClicked();
    },
    embed() {
      this.moreOpen = false;
      this.$refs.embedDialog.open(this.detail);
    },
    share() {
      this.moreOpen = false;
      this.$refs.shareDialog.open(this.detail, {
        page: this.currentPage,
        session: this.sessionId,
      });
    },
    download() {
      this.moreOpen = false;
      if (this.detail.type === 'video') {
        this.$refs.downloadSelector.open(this.detail, this.sessionId);
        return;
      }
      const alUri = `content/${this.detail.id}/download?session=${this.sessionId}&page=${this.currentPage}`;
      this.$http.get(this.$config.uri(alUri)).then(() => {});
    },
    getData() {
      this.loading = true;
      const key = (this.$route.query.key) ? `&key=${this.$route.query.key}` : '';
      const detailUri = `content/${this.$route.params.slug}?session=${this.sessionId}${key}`
        + `&pkey=${this.$route.query.pkey}&pwd=${this.pwd}`;
      this.$http.get(this.$config.uri(detailUri)).then((r) => {
        this.detail = (r.data.status === 200) ? r.data.data : null;
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
        document.title = (r.data.status === 200)
          ? `${this.detail.title} - ${this.$config.appName}`
          : `Content Not Found - ${this.$config.appName}`;
        this.loading = false;
        this.sessionId = r.data.session;
        sessionStorage.setItem('sessionId', this.sessionId);
        const relatedUri = `content/all?parentId=${this.detail.category.id}&related=${this.detail.id}&limit=5`;
        this.$http.get(this.$config.uri(relatedUri)).then((rr) => {
          this.related = (rr.data.status === 200) ? rr.data.data : null;
          this.loading = false;
        });
        if (this.detail.type === 'pdf') {
          setTimeout(() => {
            let heightOff = 0;
            const winWidth = $(window).width();
            if (winWidth > 980) heightOff = 183;
            else heightOff = 165;
            const fbH = $(window).height() - heightOff;
            $('#dfCnt').flipBook(this.detail.pdf, {
              backgroundColor: '#ede6d4',
              scrollWheel: false,
              height: fbH,
              hideControls: 'share,download',
              onFlip: (fb) => {
                this.currentPage = fb.currentPage();
                const alUri = `content/${this.detail.id}/al?session=${this.sessionId}`
                  + `&page=${this.currentPage}&uuid=${this.uuid}`;
                this.$http.post(this.$config.uri(alUri), {
                  city: this.city,
                  country: this.country,
                }).then(() => {});
              },
              onReady: (fb) => {
                if (this.$route.query.p) {
                  setTimeout(() => {
                    fb.gotoPage(this.$route.query.p);
                  }, 1200);
                }
                this.city = localStorage.getItem('city');
                this.country = localStorage.getItem('country');
                if (!this.city || this.city === 'null') {
                  this.$http.get('https://ipinfo.io?token=c698cbf39a7613').then((rrr) => {
                    this.city = rrr.data.city;
                    this.country = rrr.data.country;
                    localStorage.setItem('city', this.city);
                    localStorage.setItem('country', this.country);
                    this.signAnalytic();
                  });
                } else {
                  this.signAnalytic();
                }
              },
            });
          }, 500);
        } else if (this.detail.type === 'video') {
          const src = [];
          if (this.detail.vid1080p) src.push({ src: this.detail.vid1080p, type: 'video/mp4', size: 1080 });
          if (this.detail.vid720p) src.push({ src: this.detail.vid720p, type: 'video/mp4', size: 720 });
          if (this.detail.vid480p) src.push({ src: this.detail.vid480p, type: 'video/mp4', size: 480 });
          if (this.detail.vid360p) src.push({ src: this.detail.vid360p, type: 'video/mp4', size: 360 });
          setTimeout(() => {
            const v = this.$refs.video.player;
            v.source = { type: 'video', title: this.detail.title, sources: src };
            v.play();
          });
        } else if (this.detail.type === 'audio') {
          const src = [{ src: this.detail.audio, type: this.detail.mimetype }];
          setTimeout(() => {
            const v = this.$refs.audio.player;
            v.source = { type: 'audio', title: this.detail.title, sources: src };
            v.play();
          });
        }
      });
    },
    signAnalytic() {
      if (!this.inPage) {
        this.singingAl = false;
        return;
      }
      this.singingAl = true;
      const alUri = `content/${this.detail.id}/al?session=${this.sessionId}`
        + `&page=${this.currentPage}&uuid=${this.uuid}`;
      this.$http.post(this.$config.uri(alUri), {
        city: this.city,
        country: this.country,
      }).then((r) => {
        setTimeout(() => {
          this.singingAl = false;
          this.signAnalytic();
        }, 5000);
      });
    },
    windowFocused() {
      this.inPage = true;
      if (!this.singingAl) this.signAnalytic();
    },
    windowBlured() {
      this.inPage = false;
    },
  },
  created() {
    window.addEventListener('focus', this.windowFocused);
    window.addEventListener('blur', this.windowBlured);
    setTimeout(() => {
      document.getElementsByTagName('BODY')[0].classList.add('publication');
    });
  },
  destroyed() {
    window.removeEventListener('focus', this.windowFocused);
    window.removeEventListener('blur', this.windowBlured);
    document.getElementsByTagName('BODY')[0].classList.remove('publication');
  },
  beforeDestroy() {
    this.inPage = false;
  },
  mounted() {
    this.inPage = true;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    // document.title = `Loading Content - ${this.$config.appName}`;
    this.uuid = this.$route.query.u || '';
    this.sessionId = sessionStorage.getItem('sessionId') || '';

    // this.getData();

    setTimeout(() => {
      this.loading = false;
      this.detail.pdf = '/FIN_Issue_Brief_Ruang_Tengah_Edisi_14.pdf';
      setTimeout(() => {
        let heightOff = 0;
        const winWidth = $(window).width();
        if (winWidth > 980) heightOff = 183;
        else heightOff = 165;
        const fbH = $(window).height() - heightOff;
        $('#dfCnt').flipBook(this.detail.pdf, {
          backgroundColor: '#F1F6FF',
          scrollWheel: false,
          height: fbH,
          hideControls: 'share,download',
          onFlip: (fb) => {
            this.currentPage = fb.currentPage();
          },
          onReady: (fb) => {
            setTimeout(() => {
              if (this.$route.query.p) fb.gotoPage(this.$route.query.p);
            }, 1200);
          },
        });
      });
    }, 500);
  },
};
</script>

<style lang="scss">
.pagePubDetail{
  padding-top: 60px;
  background-color: #fff;
}
.preview{
  position: fixed;
  z-index: 991;
  left: 0; right: 0; bottom: 0;
  padding: 10px 0;
  text-align: center;
  background-color: yellow;
  color: #222;
}
#dfCnt{
  background-color: #f5f5f5;
  height: calc(100vh - 64px);
  @media (max-width: 1480px) {
    height: calc(100vh - 60px);
  }
}
.articleContent{
  &.html{
    // max-width: 1180px;
    // margin: 0 auto;
    overflow: hidden;
  }
  &.image{
    height: 640px;
    position: relative;
    background-color: #444;
    .theImg{
      position: absolute;
      left: 40px; top: 40px; right: 40px; bottom: 40px;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
  &.video{
    height: 640px;
    position: relative;
    background-color: #000;
    @media (max-width: 1200px) {
      height: 60vw;
    }
    &.youtube{
      iframe{
        width: 100%; height: 100%;
      }
    }
  }
  &.audio{
    border: #eee 1px solid;
    max-width: 1180px;
    margin: 0 auto;
    @media (max-width: 1300px) {
      max-width: 1140px;
    }
    @media (max-width: 1220px) {
      margin: 0 20px;
    }
    @media (max-width: 680px) {
      margin: 0 16px;
    }
  }
}
.sectionTitle{
  font-size: 32px;
  line-height: 1.3;
  margin: 0 auto 10px;
  max-width: 1180px;
  a{
    font-size: 17px;
    font-weight: 600;
    display: inline-block;
    border: #002f5f 1px solid;
    padding: 6px 10px 5px;
    border-radius: 2px;
    margin-top: 0px;
    float: right;
    transition: all .3s ease;
    &:hover{
      background-color: #002f5f;
      color: #fff;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    }
  }
  @media (max-width: 1300px) {
    max-width: 1140px;
  }
  @media (max-width: 1220px) {
    margin: 0 20px 10px;
  }
  @media (max-width: 680px) {
    margin: 0 16px 10px;
    font-size: 20px;
  }
}
.allContentCnt{
  padding-top: 40px;
  padding-bottom: 20px;
  max-width: 750px;
  margin: 0 auto;
  .relatedTitle{
    width: 100%;
    margin: 0;
    margin-bottom: 14px;
    font-size: 20px;
    font-size: 20px;
    padding-top: 40px;
  }
  .allContent{
    max-width: 1180px;
    margin: 0 auto;
    @media (max-width: 1300px) {
      max-width: 1140px;
    }
    @media (max-width: 1220px) {
      margin: 0 20px;
    }
    @media (max-width: 680px) {
      margin: 0 16px;
    }
    .contentCnt{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -10px;
      @media (max-width: 680px) {
        margin: 0 -8px;
      }
    }
    .contentItem{
      width: calc(33.33333% - 20px);
      margin: 0 10px 40px;
      @media (max-width: 680px) {
        width: calc(50% - 16px);
        margin: 0 8px 40px;
      }
      a{
        color: #444;
        text-decoration: none;
      }
      .contentImg{
        // height: 400px;
        border-radius: 2px;
        margin-bottom: 6px;
        position: relative;
        overflow: hidden;
        .theImg{
          width: 100%;
          height: auto;
          background-position: center;
          background-size: cover;
          background-color: #f5f5f5;
          border-radius: 5px;
          &.noImg{
            background-color: #ccc;
            background-image: url(../assets/image-white.png) !important;
            background-position: center;
            background-size: 64px auto;
            background-repeat: no-repeat;
            height: 200px;
          }
          .lnk{
            position: absolute;
            left: 0; top: 0; right: 0; bottom: 0;
            z-index: 2;
          }
        }
      }
      .contentInfo{
        position: relative;
        padding: 0 40px 0 5px;
        .contentLove{
          width: 36px; height: 36px;
          border-radius: 4px;
          position: absolute;
          right: 0; top: 0;
          background-image: url(../assets/heart.png);
          background-size: 26px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .7;
          cursor: pointer;
          &:hover{
            // background-color: #fff1f1;
            opacity: 1;
          }
          &.favorited{
            opacity: 1;
            background-image: url(../assets/heart-loved.png);
          }
          &.animating{
            opacity: 1;
            animation-name: heartAnimation;
            animation-duration: .3s;
          }
          &.animating2{
            animation-name: heartAnimation2;
            animation-duration: .3s;
          }
        }
        .category{
          text-transform: uppercase;
          color: #767676;
          font-size: 12px;
          font-weight: bold;
          a{
            color: #767676;
          }
        }
        h4{
          margin: 3px 0 6px;
          font-size: 18px;
          line-height: 1.2;
          font-family: 'Besley', serif;
        }
        .date{
          margin-top: 4px;
          font-size: 14px;
          color: #767676;
          a{
            color: #767676;
          }
        }
      }
      &.audio{
        .contentImg{
          .theImg.noImg{
            background-image: url(../assets/musical-note.png) !important;
            background-color: #d9d6e4;
          }
        }
      }
    }
  }
}


  .articleDetail{
    padding: 12px 0 0;
    .articleHeader{
      display: flex;
      max-width: 1180px;
      margin: 0 auto;
      padding-bottom: 20px;
      position: relative;
      @media (max-width: 1300px) {
        max-width: 1140px;
      }
      @media (max-width: 1220px) {
        margin: 0 20px;
      }
      @media (max-width: 680px) {
        margin: 0 16px;
        display: block;
        padding-bottom: 8px;
      }
      .ahL{
        margin-right: auto;
        .breadcrumb{
          font-size: 14px;
          white-space: nowrap;
          font-family: 'League Spartan', sans-serif;
          display: flex;
          @media (max-width: 980px){
            display: none;
          }
          .bc{
            color: #444;
            margin-right: 10px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            display: inline-block;
            max-width: 160px;
          }
          a.bc{
            color: #002f5f;
          }
          .dv{
            margin-right: 10px;
            color: #ccc;
          }
        }
        .articleTitle{
          font-size: 30px;
          margin: 10px 0 2px;
          font-family: 'Besley', serif;
          @media (max-width: 680px) {
            font-size: 22px;
            margin: 0 0 2px;
          }
        }
        .publishTime{
          font-family: 'League Spartan', sans-serif;
          color: #767676;
          @media (max-width: 680px) {
            font-size: 14px;
          }
          .bull{
            margin: 0 12px 0 10px;
            color: #999;
          }
          .category{
            text-transform: uppercase;
            font-weight: 500;
            color: #555;
          }
        }
      }
      .ahR{
        display: flex;
        align-items: center;
        @media (max-width: 680px) {
          margin: 10px 0 4px;
        }
        .articleAction{
          margin-left: 10px;
          position: relative;
          padding: 10px 16px 7px;
          padding-left: 46px;
          border-radius: 50px;
          cursor: pointer;
          transition: all .3s ease;
          background-color: #fff;
          // border: #eee 1px solid;
          color: #444;
          white-space: nowrap;
          font-family: 'League Spartan', sans-serif;
          font-size: 16px;
          font-weight: 400;
          line-height: 1;
          @media (max-width: 680px) {
            font-size: 15px;
            margin: 0;
            // margin-right: 10px;
            padding: 7px 14px 6px 34px;
          }
          &:hover{
            // background-color: #eee;
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
          }
          &:before{
            width: 16px; height: 16px;
            content: "";
            position: absolute;
            left: 16px; top: 8px;
            background-size: contain;
            background-position: center;
            background-repeat: no-repeat;
            @media (max-width: 680px) {
              width: 14px; height: 14px;
              top: 9px; left: 10px;
            }
          }
          &.embed{
            &:before{
              background-image: url(../assets/coding.png);
            }
            @media (max-width: 920px) {
              display: none;
            }
            @media (max-width: 680px) {
              // display: block;
            }
          }
          &.share{
            &:before{
              background-image: url(../assets/share.png);
            }
            @media (max-width: 920px) {
              display: none;
            }
            @media (max-width: 680px) {
              display: block;
            }
          }
          &.download{
            &:before{
              background-image: url(../assets/download-icon.png);
            }
            @media (max-width: 920px) {
              display: none;
            }
            @media (max-width: 680px) {
              display: block;
            }
          }
          &.views{
            &:before{
              background-image: url(../assets/eye.png);
            }
            @media (max-width: 920px) {
              display: none;
            }
            @media (max-width: 680px) {
              display: block;
            }
          }
          &.moreBtn{
            padding-left: 40px;
            &:before{
              background-image: url(../assets/more-veritcal.png);
            }
          }
          &.buyNow{
            padding-left: 42px;
            background-color: #002f5f;
            border-color: #002f5f;
            color: #fff;
            @media (max-width: 680px) {
              padding-left: 34px;
            }
            &:hover{
              background-color: #014b96;
              border-color: #014b96;
            }
            &:before{
              width: 20px; height: 20px;
              top: 8px;
              background-image: url(../assets/bag-white.png);
              @media (max-width: 680px) {
                width: 18px; height: 18px;
                top: 6px;
              }
            }
          }
        }
        .moreCnt{
          position: relative;
          display: none;
          @media (max-width: 920px) {
            display: block;
          }
          @media (max-width: 680px) {
            display: none;
          }
          .moreMenu{
            position: absolute;
            right: 0; top: 100%;
            z-index: 9;
            background-color: #fff;
            padding: 10px 0;
            border-radius: 5px;
            box-shadow: 2px 2px 4px rgba(0, 0, 0, .2);
            .articleAction{
              position: relative;
              padding: 12px 36px 10px;
              font-size: 16px;
              white-space: nowrap;
              padding-left: 58px;
              display: block;
              margin: 0;
              border-radius: 0;
              border: none;
              min-width: 80px;
              &:hover{
                background-color: #eee;
              }
              &:before{
                width: 18px; height: 18px;
                content: "";
                position: absolute;
                left: 24px; top: 9px;
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                @media (max-width: 680px) {
                  width: 16px;
                  top: 5px;
                }
              }
              &.embed{
                &:before{
                  background-image: url(../assets/coding.png);
                }
              }
              &.share{
                &:before{
                  background-image: url(../assets/share.png);
                }
              }
              &.download{
                &:before{
                  background-image: url(../assets/download-icon.png);
                }
              }
              &.views{
                &:before{
                  background-image: url(../assets/eye.png);
                }
              }
            }
          }
        }
      }
    }
  }
</style>

<style scoped lang="scss">
.protected{
  padding: 200px 0;
  text-align: center;
  background-color: #f5f5f5;
  img{
    opacity: .8;
    margin-bottom: 20px;
    height: 84px;
    opacity: .75;
  }
  h4{
    margin: 0 0 2px;
  }
  p{
    color: #767676;
    margin: 0;
  }
  .inputCnt{
    margin-top: 16px;
    position: relative;
    display: inline-block;
    width: 300px;
    .privateIcon{
      position: absolute;
      left: 8px; top: 8px;
      width: 30px; height: 30px;
      background-image: url(../assets/private.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .3;
    }
    button{
      position: absolute;
      width: 40px; height: 40px;
      border: none;
      border-radius: 50%;
      right: 4px; top: 4px;
      transition: all .3s ease;
      background-image: url(../assets/arrow-right-bold.png);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
      background-color: #fff;
      opacity: .6;
      &:hover{
        background-color: #eee;
        opacity: 1;
      }
    }
    input{
      border-radius: 5px;
      border: #ccc 1px solid;
      padding: 10px 20px;
      text-align: center;
      font-size: 20px;
      width: 100%;
      box-sizing: border-box;
    }
  }
}

.notFound{
  position: absolute;
  left: 40px; right: 40px;
  top: 50%; transform: translateY(-50%);
  text-align: center;
  color: #767676;
  img{
    height: auto;
    width: 100%;
    max-width: 500px;
    margin-bottom: 40px;
  }
  h2{
    margin: 0 0 4px;
    font-size: 30px;
    line-height: 1;
  }
  h4{
    margin: 0;
    font-size: 50px;
    line-height: 1;
  }
  button{
    margin-top: 20px;
  }
  p{
    margin: 0;
  }
}
</style>
